import { render } from "./App.vue?vue&type=template&id=7ca7f89f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7ca7f89f&lang=scss"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\AnnonsAvd\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__